export enum LocationGroupGranularityType {
  Address = 'address',
  City = 'city',
  Country = 'country',
}
